const carouselItems = [
  {
    title: '2026上半年塌房年鉴',
    desc: '从千万粉大主播到腰部网红，47起重大塌房事件全记录。人设崩塌、假货翻车、税务风波、法律追责——网红圈的2026上半年堪称塌房元年。深度复盘每一个翻车案例的起因、经过、结果。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20abstract%20collage%20of%20shattered%20mirrors%20and%20fractured%20surfaces%2C%20crimson%20and%20gold%20accents%2C%20metaphorical%20representation%20of%20shattered%20reputations%2C%20cinematic%20lighting%2C%20atmospheric%20texture%2C%20conceptual%20art&width=900&height=500&seq=carousel-01&orientation=landscape',
    tag: '年度盘点',
  },
  {
    title: 'MCN暗箱操作全揭秘',
    desc: '流量造假、数据注水、霸王合同、恶意挖角——揭开网红经纪公司光鲜表面下的暗黑运作模式。多位前MCN从业者匿名爆料，还原行业内最真实的面貌。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20corporate%20boardroom%20with%20shadowy%20figures%2C%20dramatic%20backlighting%20through%20blinds%2C%20papers%20scattered%2C%20mysterious%20atmosphere%2C%20conspiracy%20thriller%20aesthetic%2C%20cinematic%20photography%2C%20high%20contrast&width=900&height=500&seq=carousel-02&orientation=landscape',
    tag: '深度调查',
  },
  {
    title: '网红税务风波全追踪',
    desc: '从补税到立案，从自查到刑责——2026年网红圈最大税务风暴来袭。累计涉案金额超10亿元，数十位头部主播被约谈，行业税收规范或将迎来巨变。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20abstract%20composition%20of%20falling%20legal%20documents%20and%20currency%20symbols%2C%20dramatic%20crimson%20and%20charcoal%20gradients%2C%20atmospheric%20lighting%2C%20metaphorical%20representation%20of%20financial%20crisis%2C%20conceptual%20fine%20art&width=900&height=500&seq=carousel-03&orientation=landscape',
    tag: '税务风暴',
  },
  {
    title: '从爆火到塌房：网红生命周期白皮书',
    desc: '数据统计显示，2024-2026年抖音快手网红平均"保鲜期"仅11个月。我们追踪了100位网红从崛起到衰落的全过程，总结出五大塌房模式与三大预警信号。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20abstract%20timeline%20visualization%2C%20ascending%20then%20plummeting%20line%20graph%2C%20crimson%20and%20charcoal%20tones%2C%20dramatic%20atmospheric%20lighting%2C%20conceptual%20data%20art%2C%20cinematic%20mood%2C%20brooding&width=900&height=500&seq=carousel-04&orientation=landscape',
    tag: '数据分析',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">焦点专题</h2>
            <p className="mt-2 text-sm text-foreground-500">深度策划的重磅专题，一次性看透网红圈大事件</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
            {carouselItems.map((item, idx) => (
              <div
                key={idx}
                className="group cursor-pointer rounded-xl overflow-hidden bg-background-200/70 border border-background-300/40 hover:border-primary-500/30 transition-all duration-300"
              >
                <div className="relative aspect-[16/10] overflow-hidden">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-background-50/80 via-transparent to-transparent"></div>
                  <div className="absolute top-3 left-3">
                    <span className="inline-block text-xs font-medium px-2.5 py-1 rounded-full bg-primary-500/85 text-background-50 whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                  <div className="absolute bottom-3 left-3 right-3">
                    <h3 className="text-sm font-semibold text-foreground-950 leading-snug">
                      {item.title}
                    </h3>
                  </div>
                </div>
                <div className="p-4">
                  <p className="text-xs text-foreground-500 leading-relaxed line-clamp-3">
                    {item.desc}
                  </p>
                  <div className="mt-3 flex items-center gap-1 text-xs text-primary-500 group-hover:gap-2 transition-all duration-200">
                    <span>查看专题</span>
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-arrow-right-line text-xs"></i>
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}